import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigationHelper } from 'FrontRoyalAngular';
import { SidebarBoxKey } from 'AdmissionsGuidance';
import { BasicMobileBox } from '../../BasicMobileBox';
import { ImportantCtaBox } from '../../ImportantCtaBox';

type PresentationProps = {
    onPressCta: () => void;
};

function CompleteApplicationBoxComponent({ mobile }: { mobile?: boolean }) {
    const { loadRoute } = useNavigationHelper();
    const onPressCta = useCallback(() => {
        loadRoute('/settings/application');
    }, [loadRoute]);

    return mobile ? (
        <CompleteApplicationBoxMobilePresentation onPressCta={onPressCta} />
    ) : (
        <CompleteApplicationBoxPresentation onPressCta={onPressCta} />
    );
}

function CompleteApplicationBoxMobilePresentation({ onPressCta }: PresentationProps) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'completeApplicationBox' });

    return (
        <BasicMobileBox
            boxKey={SidebarBoxKey.complete_application}
            buttonId="cta"
            heading={t('mobileTitle')}
            ctaText={t('ctaText')!}
            onPress={onPressCta}
        />
    );
}

export function CompleteApplicationBoxPresentation({ onPressCta }: PresentationProps) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'completeApplicationBox' });
    return (
        <ImportantCtaBox
            headerSubtitle={t('subtitle')}
            headerTitle={t('title')}
            ctaText={t('ctaText')!}
            onPressCta={onPressCta}
            boxKey={SidebarBoxKey.complete_application}
            testId="complete-application-box"
        >
            {t('description')}
        </ImportantCtaBox>
    );
}

export const CompleteApplicationBox = memo(CompleteApplicationBoxComponent);
